(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.testimonial-carousel').owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    animateOut: 'fadeOut',
    smartSpeed: 800
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-gsap"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    'use strict';

    gsap.registerPlugin(ScrollTrigger);

    let workInfoItems = document.querySelectorAll('.work__photo-item');
    workInfoItems.forEach(function(item, index) {
        item.style.zIndex = workInfoItems.length - index;
    });    

    gsap.set(".work__photo-item",{
        clipPath: function () {
            return "inset(0px 0px 0px 0px)"
        },
    });

    const animation = gsap.to('.work__photo-item:not(:last-child)',{
        clipPath: function () {
            return "inset(0px 0px 100% 0px)"
        },
        stagger:.5,
        ease:"none"
    })

    ScrollTrigger.create ({
        trigger:".work",
        start:'top top',
        end: 'bottom bottom',
        animation:animation,
        scrub:1 
    })
});

  } catch(e) { console.error(e); }
})();
})();
